/**
 * Review glass surface (frame khM98). Fill, gradient border, inner light,
 * shadow and the 32px radius all come from revisaoSurfaces / the glass tokens.
 */
import type { ReactNode } from "react";
import {
  revisaoGlassBorderClass,
  revisaoGlassFaceClass,
} from "./revisaoSurfaces";

export interface GlassCardProps {
  children?: ReactNode;
  /** Merged onto the outer shell (width, height). Do not pass colour classes. */
  className?: string;
}

export function GlassCard({ children, className = "" }: GlassCardProps) {
  return (
    <div className={`${revisaoGlassBorderClass} ${className}`.trim()}>
      <div className={revisaoGlassFaceClass}>{children}</div>
    </div>
  );
}
